import { endOfMonth, subMonths } from "date-fns";
import * as XLSX from "xlsx";

const xlsx_to_json = (file: File): Promise<any> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = (e) => {
      if (e.target && e.target.result) {
        const data = e.target.result as ArrayBuffer;
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const raw_data: any = XLSX.utils.sheet_to_json(worksheet);
        resolve(raw_data)
      }
    };
    reader.onerror = (e) => {
      reject(new Error('An error occurred while reading the file.'));
    };
  });
}


const getUTC = (utc: Date): Date => {
  const date = new Date(utc);
  return new Date(`${date.getUTCFullYear()}-${date.getUTCMonth() + 1}-${date.getUTCDate()}`);
}

const addZero = new Map([
  ["1", "01"],
  ["2", "02"],
  ["3", "03"],
  ["4", "04"],
  ["5", "05"],
  ["6", "06"],
  ["7", "07"],
  ["8", "08"],
  ["9", "09"],
  ["10", "10"],
  ["11", "11"],
  ["12", "12"],
  ["13", "13"],
  ["14", "14"],
  ["15", "15"],
  ["16", "16"],
  ["17", "17"],
  ["18", "18"],
  ["19", "19"],
  ["20", "20"],
  ["21", "21"],
  ["22", "22"],
  ["23", "23"],
  ["24", "24"],
  ["25", "25"],
  ["26", "26"],
  ["27", "27"],
  ["28", "28"],
  ["29", "29"],
  ["30", "30"],
  ["31", "31"],
]);

const getDateString = (utc: Date | null) => {
  if (utc === null) {
    return "";
  }
  const [dd, mm, yyyy] = utc.toLocaleDateString("en-IN").split("/");
  return `${yyyy}-${addZero.get(mm)}-${ addZero.get(dd)}`;
}

const getTimeString = (utc: Date | null): string | undefined => {
  if (utc === null) {
    return;
  }
  const [hh, mm, ss] = utc.toLocaleTimeString('en-IN', { hour12: false }).split(":");
  return `${hh}:${mm}:${ss}`;
}



const formatDateTime = (isoString: string): Array<string> => {
  // Step 1: Parse the ISO 8601 string into a Date object
  const date = new Date(isoString);

  // Step 2: Add 5 hours and 30 minutes
  date.setUTCHours(date.getUTCHours() + 5);
  date.setUTCMinutes(date.getUTCMinutes() + 30);

  // Step 3: Extract the components
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const month = months[date.getUTCMonth()];
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  // Step 4: Format the time to 12-hour format
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  // Step 5: Create the formatted date and time strings
  const [d1, d2, d3, d4] = year?.toString().split("");
  const formattedDate = `${day}-${month}-${d3}${d4}`;
  const formattedTime = `${hours}:${minutes}${ampm}`;

  return [formattedDate, formattedTime];
}

// function formatCurrentDate(): string {
//   const today = new Date();

//   const year = today.getFullYear();
//   const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
//   const day = String(today.getDate()-1).padStart(2, "0");

//   return `${year}-${month}-${day}`; // Format: YYYY-MM-YY
// }

function formatDate(inputDate: Date): string {
  const year = inputDate.getFullYear();
  const month = (inputDate.getMonth() + 1).toString().padStart(2,'0'); // Months are 0-indexed
  const day = inputDate.getDate().toString().padStart(2,'0');
  return `${year}-${month}-${day}`;
}


export default xlsx_to_json;

// function getNextTimes() {
//   const now = new Date();

//   let currentHour = now.getHours();

//   let nextHour = currentHour;

//   if (nextHour >= 24) {
//     nextHour = 0;
//   }

//   let nextToNextHour = nextHour + 1;

//   if (nextToNextHour >= 24) {
//     nextToNextHour = 0;
//   }
//   const formatTime = (hour: any) => {
//     const ampm = hour >= 12 ? 'PM' : 'AM';
//     hour = hour % 12;
//     hour = hour ? hour : 12;
//     return `${hour}:${"00"} ${ampm}`;
//   };

//   return {
//     nextTime: formatTime(nextHour),
//     nextToNextTime: formatTime(nextToNextHour),
//   };
// }

function getNextTimes(date = new Date()) {
  // Get the next hour
  const nextHour = new Date(date);
  nextHour.setMinutes(0, 0, 0); // Set minutes, seconds, and milliseconds to 0
  nextHour.setHours(nextHour.getHours() + 1); // Increment the hour

  // Get the hour after next
  const nextToNextHour = new Date(nextHour);
  nextToNextHour.setHours(nextToNextHour.getHours() + 1); // Increment the hour again

  return {
    nextTime: nextHour.toTimeString().slice(0, 5), // Return time in HH:mm format
    nextToNextTime: nextToNextHour.toTimeString().slice(0, 5) // Return time in HH:mm format
  };
}


const getFutureDate = (days: number) => {
  const today = new Date();
  const futureDate = new Date(today);
  futureDate.setDate(today.getDate() + days);
  return futureDate;
}

const getNextMonthLastDate = () => {
  const today = new Date();
  const lastDayOfNextMonth = new Date(today.getFullYear(), today.getMonth() + 2, 0);
  return lastDayOfNextMonth;
}


const getNextEvent = (start_time_stamp: string, end_time_stamp: string, days: number[], time_slot: string[]): Array<string> => {

  let today = getUTC(new Date());

  if (today.getTime() < new Date(start_time_stamp).getTime()) {
    today = new Date(start_time_stamp);
  }


  let dates: Date[] = [];
  const times: string[] = [];
  let end_time_stamp_obj = new Date(end_time_stamp);
  while (today <= end_time_stamp_obj) {
    let todayDay = today.getDay();
    if (days.includes(todayDay)) {

      const currentHour = new Date().getHours();
      const currentMin = new Date().getMinutes();

      const totalCurrentMin = (currentHour * 60) + currentMin;

      for (let i = 0; i < time_slot.length; i++) {
        const [hr, min] = time_slot[i].split(":");

        const totalMin = (parseInt(hr) * 60) + parseInt(min)
        if (today.getTime() === getUTC(new Date()).getTime() && totalMin > totalCurrentMin) {

          times.push(time_slot[i]);
          dates.push(new Date(today));
        } else if (today > getUTC(new Date())) {
          times.push(time_slot[i]);
          dates.push(new Date(today));
        }

        if (times.length) {
          break;
        }
      }

    }
    if (dates.length) {
      break;
    }
    today.setDate(today.getDate() + 1);
  }

  let [nextDate] = dates;

  if (!nextDate) {
    return []
  }

  const [nextTime] = times;
  if (!nextTime) {
    return []
  }
  return [nextDate.toString(), nextTime]
}

const canEdit = (pdate: string, ptime: string) => {
  const date = getDateString(new Date(pdate));
  const date_time = new Date();
  return new Date(`${date}T${ptime}`) > date_time;
}

function formatWeekInputForCsv(input:{year:string, month: string, week: string}) {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const year = input.year.slice(-2); // Get the last two digits of the year
  const monthIndex = parseInt(input.month, 10) - 1; // Convert month to zero-based index
  const monthName = monthNames[monthIndex];
  const week = `W${input.week}`;

  return `${week}-${monthName}-${year}`;
}
function formatWeekInput(input:{year:string, month: string, week: string}) {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const year = input.year.slice(-2); // Get the last two digits of the year
  const monthIndex = parseInt(input.month, 10) - 1; // Convert month to zero-based index
  const monthName = monthNames[monthIndex];
  const week = `W${input.week}`;

  return `${week}, ${monthName}'${year}`;
}

function formatWeekInputForGrid(input:{year:string, month: string, week: string}) {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const year = input.year.slice(-2); // Get the last two digits of the year
  const monthIndex = parseInt(input.month, 10) - 1; // Convert month to zero-based index
  const monthName = monthNames[monthIndex];
  const week = `W${input.week}`;

  return `${week}_${monthName}_${year}`;
}

function formatDatefunc(input:{ date: string }) {
  const date = new Date(input.date); // Convert input date string to a Date object
  const options: Intl.DateTimeFormatOptions = {
    weekday: "short", // Use proper value
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  };

  // Format date as "Mon 01/10/2024"
  return date.toLocaleDateString("en-IN", options).replace(',', ''); // Remove comma for clean formatting
}

function formatMonthYear(input: {year: string, month: string}) {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const year = input.year;
  const monthIndex = parseInt(input.month, 10) - 1; // Convert to zero-based index
  const monthName = monthNames[monthIndex];

  return `${monthName} ${year}`;
}
const getYearsFromRange = (min_date: Date, max_date: Date) => {
  const startYear = min_date.getFullYear();
  const endYear = max_date.getFullYear();
  const new_years: number[] = [];
  for (let year = startYear; year <= endYear; year++) {
    new_years.push(year);
  }
  return new_years;
};
const getYearsFromGivenRange = (min_date: Date, max_date: Date) => {
  const startYear = min_date?.getFullYear();
  const endYear = max_date?.getFullYear();
  type YearProps = {
    id: string,
    label: string
  }
  const new_years: YearProps[] = [];
  for (let year = startYear; year <= endYear; year++) {
    new_years.push({id: String(year), label : String(year)});
  }
  return new_years;
};
const formatToDDMMYYYY = (date: Date): string  => {
  const day = String(date.getDate()).padStart(2, '0'); // Get the day, padded to 2 digits
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Get the month (0-based, so add 1), padded to 2 digits
  const year = date.getFullYear(); // Get the full year
  return `${day}/${month}/${year}`; // Combine in DD/MM/YYYY format
}

interface MonthProps {
  id: string;
  label: string;
}

interface MonthProps {
  id: string;
  label: string;
}

function getMonthsInRange(date1: Date, date2: Date): MonthProps[] {
  const allMonths: MonthProps[] = [
    { id: "1", label: "January" },
    { id: "2", label: "February" },
    { id: "3", label: "March" },
    { id: "4", label: "April" },
    { id: "5", label: "May" },
    { id: "6", label: "June" },
    { id: "7", label: "July" },
    { id: "8", label: "August" },
    { id: "9", label: "September" },
    { id: "10", label: "October" },
    { id: "11", label: "November" },
    { id: "12", label: "December" },
  ];

  // Ensure startDate is before endDate
  const startDate = new Date(Math.min(date1?.getTime(), date2?.getTime()));
  const endDate = new Date(Math.max(date1?.getTime(), date2?.getTime()));

  const result: MonthProps[] = [];

  // Loop through each month in the range
  while (startDate <= endDate) {
    const monthIndex = startDate?.getMonth(); // 0-based month index
    result.push(allMonths[monthIndex]);
    startDate.setMonth(startDate?.getMonth() + 1); // Increment month
  }

  // Add the current month if not already in the result
  const currentDate = new Date();
  const currentMonthIndex = currentDate?.getMonth(); // Get current month index
  const currentMonth = allMonths[currentMonthIndex];

  if (!result.some((month) => month.id === currentMonth.id)) {
    result.push(currentMonth); // Add current month if it's not already included
  }

  // Remove duplicates and return the result
  const uniqueMonths = Array.from(new Set(result.map((month) => month.id))).map(
    (id) => allMonths.find((month) => month.id === id)!
  );

  return uniqueMonths;
}

function getMonthName(monthNumber: number): string {
  const allMonths = [
    "January", "February", "March", "April", "May", 
    "June", "July", "August", "September", "October", 
    "November", "December"
  ];

  if (monthNumber < 1 || monthNumber > 12) {
    throw new Error("Invalid month number. Please provide a number between 1 and 12.");
  }

  return allMonths[monthNumber - 1]; // Convert 1-based to 0-based index
}

const getDatesBetween = (startDate: string, endDate : string) => {
  let dates = [];
  let currentDate = new Date(startDate);
  let stopDate = new Date(endDate);

  while (currentDate <= stopDate) {
      dates.push(currentDate.toISOString().split('T')[0]); // Formats as YYYY-MM-DD
      currentDate.setDate(currentDate?.getDate() + 1);
  }

  return dates;
}

const getWeeksBetween = (startDate : string, endDate : string) => {
  let start = new Date(startDate);
  let end = new Date(endDate);
  let weeks = new Set();

  while (start <= end) {
      let year = start?.getFullYear();
      let month = (start?.getMonth() + 1).toString().padStart(2, '0');
      let day = start?.getDate();

      let isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
      let daysInMonth = new Date(year, start?.getMonth() + 1, 0).getDate();

      // Ensure February has 5 weeks in a leap year when it has 29 days
      let totalWeeks = (month === "02" && isLeapYear && daysInMonth === 29) ? 5 : Math.ceil(daysInMonth / 7);

      let weekNumber = Math.ceil(day / 7);
      if (weekNumber > totalWeeks) weekNumber = totalWeeks;

      weeks.add(`${year}-${month}-WEEK-${weekNumber.toString().padStart(2, '0')}`);

      start.setDate(start?.getDate() + 1);
  }

  return Array.from(weeks) as string[];
}

const getMonthsBetween = (startDate : string , endDate : string) => {
  let start = new Date(startDate);
  let end = new Date(endDate);
  let months = new Set();

  while (start <= end) {
      let year = start?.getFullYear();
      let month = (start?.getMonth() + 1).toString().padStart(2, '0');
      months.add(`${year}-${month}`);

      // Move to the next month
      start.setMonth(start?.getMonth() + 1);
      start.setDate(1); // Ensure it stays at the first day of the month
  }

  return Array.from(months) as string[];
}

// const getFormattedValue = (value: number) => {
//   if (value === null || value === undefined) return 0; // Default to "0" if null/undefined

//   const numValue = Number(value); // Convert to a number
//   if (isNaN(numValue)) return 0; // If not a valid number, return "0"

//   return Number(value?.toFixed(4)); // Otherwise, format it to 4 decimal places
// };

const getFormattedValue = (value: number) => {

  if (value === null || value === undefined) return '0'; // Default to "0" if null/undefined

  const numValue = Number(value); // Convert to a number
  if (isNaN(numValue)) return ; // If not a valid number, return "0"

  // // Check if the number is negative and remove the negative sign for formatting
  // const isNegative = numValue < 0;
  // const absoluteValue = Math.abs(numValue);

  // // Format the number to 4 decimal places
  // const formattedNumber = absoluteValue.toFixed(4);

  // // Split the integer part and decimal part
  // const [integerPart, decimalPart] = formattedNumber.split('.');

  // // If the decimal part is '0000', return only the integer part (without the decimal)
  // if (decimalPart === '0000') {
  //   return (isNegative ? '-' : '') +  integerPart.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
  // }
  
  // return integerPart?.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,") + (decimalPart ? ("."+decimalPart): "")
  return String(value)?.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
}

const removeCommas = (formattedValue: string | undefined): string => {
  if (!formattedValue) {
    return '';
  }
    // Remove commas and return the result
    return formattedValue?.replace(/,/g, '');
    // return formattedValue;
  };

const convertTotalData = (
  backendSubTotalData: any,
  selectedMatrics: string[]
) => {
  const outputData: any = {};

  selectedMatrics.forEach((metric) => {
    const currentKey = `${metric}_current`;
    const previousKey = `${metric}_previous`;
    const differenceKey = `${metric}_difference`;
    const percentageKey = `${metric}_difference_percentage`;

    outputData[metric] = {
      current: getFormattedValue(backendSubTotalData[currentKey]),
      previous: getFormattedValue(backendSubTotalData[previousKey]),
      difference: getFormattedValue(backendSubTotalData[differenceKey]),
      difference_percentage: getFormattedValue(backendSubTotalData[percentageKey])
    };
  });

  return [outputData];
};

function findLastLevel(
    present: string[],
    hierarchy: string[]
  ): string | null {
    // Reverse iterate through hierarchy to find the last matching level
    for (let i = hierarchy.length - 1; i >= 0; i--) {
      if (present.includes(hierarchy[i])) {
        return hierarchy[i]; // Return the last matching level
      }
    }
    return null; // Return null if no match found
  }
  
type DynamicObject = {
    [key: string]: any;
  };
type MetricData = {
    current: string | undefined;
    previous: string | undefined;
    difference: string | undefined;
    difference_percentage: string | undefined;
  };
type RowData = { [key: string]: MetricData };

  const transformToComparisonTable = (
    resultdata: DynamicObject[],
    product_det_hierarchy: string[],
    present: string[],
    metrics_hierarchy: string[],
    sel_metrics: string[]
  ) => {
    const comparisonTableData: any[] = [];
    const rows_data: any[] = [];
    resultdata.forEach((item) => {

      let currentLevel = comparisonTableData;
      let lastlevel = findLastLevel(present, product_det_hierarchy);
      product_det_hierarchy.forEach((level) => {
        // Only process levels that are in the `present` array
        if (present.includes(level)) {
          const levelName = item[level] || "";
          let existingLevel = currentLevel?.find((l) => l.name === levelName);

          if (!existingLevel) {
            if (lastlevel === level) {
              const singleRow: RowData = {};
              metrics_hierarchy.forEach((metric) => {
                if (sel_metrics.includes(metric)) {
                  singleRow[metric] = {
                    current: item[`${metric}_current`] !== null ? getFormattedValue(item[`${metric}_current`]) : "0",
                    previous: item[`${metric}_previous`] !== null ? getFormattedValue(item[`${metric}_previous`]) : "0",
                    difference: item[`${metric}_difference`] !== null ? getFormattedValue(item[`${metric}_difference`]) : "0",
                    difference_percentage: item[`${metric}_difference_percentage`] !== null ? getFormattedValue(item[`${metric}_difference_percentage`]) : "0",
                  };
                }
              });
              existingLevel = {
                type: level,
                name: levelName,
                row: [singleRow],
              };
              rows_data?.push(singleRow);
              currentLevel?.push(existingLevel);
            } else if (lastlevel !== level) {
              existingLevel = {
                type: level,
                name: levelName,
                children: [],
              };
              currentLevel?.push(existingLevel);
            }
          }
          currentLevel = existingLevel.children;
        }
      });
      if (currentLevel && lastlevel) {
        const singleRow: RowData = {};
        metrics_hierarchy.forEach((metric) => {
          if (sel_metrics.includes(metric)) {
              singleRow[metric] = {
                current: item[`${metric}_current`] !== null ? getFormattedValue(item[`${metric}_current`]) : "0",
                previous: item[`${metric}_previous`] !== null ? getFormattedValue(item[`${metric}_previous`]) : "0",
                difference: item[`${metric}_difference`] !== null ? getFormattedValue(item[`${metric}_difference`]) : "0",
                difference_percentage: item[`${metric}_difference_percentage`] !== null ? getFormattedValue(item[`${metric}_difference_percentage`]) : "0",
              };
          }
        });
        rows_data?.push(singleRow);
        currentLevel.push(singleRow);
      }
    });
    return {comparisonTableData, rows_data};
  };

  const transformToSummaryTable = (
    resultdata: DynamicObject[],
    product_det_hierarchy: string[],
    sel_product_details_columns: string[],
    metrics_hierarchy: string[],
    sel_metrics: string[],
    period_type: string,
    datesArr: string[],
    weeksArr: string[],
    monthsArr: string[]
  ) => {
    const summaryTableData: any[] = [];
    const rows_data: any[] = [];

    resultdata.forEach((item) => {
      let currentLevel = summaryTableData;
      let lastlevel = findLastLevel(
        sel_product_details_columns,
        product_det_hierarchy
      );

      product_det_hierarchy.forEach((current_level) => {
        if (sel_product_details_columns.includes(current_level)) {
          const levelName = item[current_level] || "";
          let existingLevel = currentLevel?.find((l) => l?.name === levelName);

          if (!existingLevel) {
            if (current_level === lastlevel) {
              let singleRow: any[] = [];
              if (period_type === "day") {
                datesArr.forEach((date) => {
                  const rowEntry: any = { date: date };
                  rowEntry[date] = {};

                  sel_metrics.forEach((metric) => {
                    if (metrics_hierarchy.includes(metric)) {
                      rowEntry[date][metric] =  getFormattedValue(item[`${metric}_${date}`]); // Initialize with default values (replace with actual data if available)
                    }
                  });
                  singleRow.push(rowEntry);
                });
              } else if (period_type === "week") {
                weeksArr.forEach((week) => {
                  const rowEntry: any = { date: week };
                  rowEntry[week] = {};

                  sel_metrics.forEach((metric) => {
                    if (metrics_hierarchy.includes(metric)) {
                      rowEntry[week][metric] = getFormattedValue(item[`${metric}_${week}`]); // Initialize with default values (replace with actual data if available)
                    }
                  });
                  singleRow.push(rowEntry);
                });
              } else if (period_type === "month") {
                monthsArr.forEach((month) => {
                  const rowEntry: any = { date: month };
                  rowEntry[month] = {};

                  sel_metrics.forEach((metric) => {
                    if (metrics_hierarchy.includes(metric)) {
                      rowEntry[month][metric] =  getFormattedValue(item[`${metric}_${month}`]); // Initialize with default values (replace with actual data if available)
                    }
                  });
                  singleRow.push(rowEntry);
                });
              } else if (period_type === "all") {
                const rowEntry: any = { date: "all" };
                rowEntry["all"] = {};
                sel_metrics.forEach((metric) => {
                  if (metrics_hierarchy.includes(metric)) {
                    rowEntry["all"][metric] =  getFormattedValue(item[`${metric}_all`]); // Initialize with default values (replace with actual data if available)
                  }
                });
                singleRow.push(rowEntry);
              }
              existingLevel = {
                type: current_level,
                name: levelName,
                row: [singleRow],
              };
              rows_data.push(singleRow);
              currentLevel.push(existingLevel);
            } else if (current_level !== lastlevel) {
              existingLevel = {
                type: current_level,
                name: levelName,
                children: [],
              };
              currentLevel.push(existingLevel);
            }
          }
          currentLevel = existingLevel.children;
        }
      });
    });

    return {summaryTableData, rows_data};
  };

  const convertToCSV = (data : any) => {
    const headers = Object.keys(data[0]).join(","); // Extract column names
    const rows = data.map((row : any)  => 
        Object.values(row).map(value => 
            (typeof value === "string" && value.includes(",")) ? `"${value}"` : value
        ).join(",")
    );

    return [headers, ...rows].join("\n");
  };

  // For Converting Backend Data into CSV File download 
  const downloadCSV = (data: any, filename = "result.csv") => {
      const csvContent = convertToCSV(data);
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
  };
  
  const getWeekRange = (date: Date) => {
      const todayDate = date.getDate();
  
      // Define fixed week ranges
      const weeks: [number, number][] = [
        [1, 7],
        [8, 14],
        [15, 21],
        [22, 28],
        [29, 31],
      ];
  
      // Find the index of the current week
      const currentWeekIndex = weeks.findIndex(
        ([start, end]) => todayDate >= start && todayDate <= end
      );
      if (currentWeekIndex === -1) return null; // Fallback in case no match is found
  
      // Get the current and previous week's range
      const [currentStart, currentEnd] = weeks[currentWeekIndex];
  
      let prevStart, prevEnd, month, year;
      if (currentStart === 1 && currentEnd === 7) {
        const lastMonthDate = subMonths(date, 1);
        const prevMonthLastDate = endOfMonth(lastMonthDate)?.getDate();
  
        const prevWeek = weeks.find(
          ([start, end]) => prevMonthLastDate >= start && prevMonthLastDate <= end
        );
        prevStart = prevWeek?.[0];
        prevEnd = endOfMonth(lastMonthDate)?.getDate();
        month = lastMonthDate?.getMonth();
        year = lastMonthDate?.getFullYear();
      } else {
        const lastweek = weeks[currentWeekIndex - 1] || [1, 7]; // Default to first week if no previous
        prevStart = lastweek?.[0];
        prevEnd = lastweek?.[1];
        month = date?.getMonth();
        year = date?.getFullYear();
      }
  
      return {
        previousWeekStart: new Date(year, month, prevStart),
        previousWeekEnd: new Date(year, month, prevEnd),
        currentWeekStart: new Date(
          date?.getFullYear(),
          date?.getMonth(),
          currentStart
        ),
      };
    };

export {
  formatDateTime,
  getNextTimes,
  getUTC,
  getNextEvent,
  getDateString,
  getTimeString,
  canEdit,
  getFutureDate,
  getNextMonthLastDate,
  formatDate,
  formatWeekInput,
  formatWeekInputForCsv,
  formatWeekInputForGrid,
  formatDatefunc,
  formatMonthYear,
  getYearsFromRange,
  getYearsFromGivenRange,
  formatToDDMMYYYY,
  getMonthsInRange,
  getMonthName,
  getDatesBetween,
  getWeeksBetween,
  getMonthsBetween,
  convertTotalData,
  transformToComparisonTable,
  transformToSummaryTable,
  downloadCSV,
  removeCommas,
  getFormattedValue,
  getWeekRange
}
